import {Grid, GridItem} from "@consta/uikit/Grid";
import {Button} from "@consta/uikit/Button";
import React, {useEffect, useState} from "react";
import "../css/pageBsi.css";
import {DragNDropField} from '@consta/uikit/DragNDropField';
import {Text} from '@consta/uikit/Text';
import GridBsiBsiList from "./component/grid.bsi.bsiList";
import ModalBsiPayload, {readFile} from "./component/modal.bsi.payload";
import ModalBsiDiagram from "./component/modal.bsi.diagram";
import {Tabs} from "@consta/uikit/Tabs";
import {IconPhoto} from "@consta/uikit/IconPhoto";
import {IconRing} from "@consta/uikit/IconRing";
import {IconComponent} from "@consta/uikit/Icon";
import {SnackCmp} from "../../component/snack.cmp";
import {ProcessingType} from "./component/modal.bsi.payload";
import http from "../../service/axiosConfig";
import {
    API_BSI_AUTO_MATCHES,
    API_BSI_AUTO_MATCHES_REFRESH,
    API_BSI_TEHSMART_ARCHIVE,
    API_BSI_TEHSMART_REFRESH,
    API_DRAMATIQ_TASK_RESULT
} from "../../service/api.endpoint";

type Item = {
    name: string;
    image?: IconComponent;
};

const items: Item[] = [
    {
        name: "Загрузка",
        image: IconPhoto
    },
    {
        name: "Сервер",
        image: IconRing
    },
    {
        name: "Автозагрузка",
        image: IconRing
    }
];

const PageBsi = () => {
    const [tabsValue, setTabsValue] = useState<Item | null>(items[0]);
    const [files, setFiles] = React.useState<File[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDiagramOpen, setIsModalDiagramOpen] = useState(false);
    const [newRowData, setNewRowData] = useState<any>(null);
    const [bsiFileDiagram, setBsiFileDiagram] = useState<string | null>();
    const [bsiDiagramFileName, setBsiDiagramFileName] = useState<string>('');
    const [isDiagramFileReading, setIsDiagramFileReading] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [processingData, setProcessingData] = useState<ProcessingType[]>([]);

    useEffect(() => {
        document.title = 'АСПО.Контроль | БСИ';
    }, []);

    const handleModalClose = (value: any) => {
        setIsModalOpen(false);
        if (value && value !== false) {
            // value теперь это processingData (массив)
            if (Array.isArray(value) && value.length > 0) {
                setProcessingData(value);
                setShowSnackbar(true);
                setNewRowData(value); // Обновляем данные для таблицы

                // Скрываем снекбар через 4 секунды после последнего уведомления
                setTimeout(() => {
                    setShowSnackbar(false);
                    setProcessingData([]);
                }, 4000);
            }
        }
    };

    const handleDropFiles = (files: any) => {
        setFiles(files)
        setIsModalOpen(true)
    }

    const handleDropFilesDiagram = (files: any) => {
        const file = files?.[0]

        if (!file) {
            return
        }

        setBsiFileDiagram(null)
        setBsiDiagramFileName(file.name || '')
        setIsDiagramFileReading(true)
        setIsModalDiagramOpen(true)

        readFile(file)
            .then((contents: any) => {
                setBsiFileDiagram(contents)
            })
            .finally(() => setIsDiagramFileReading(false))
    }

    const handleModalDiagramClose = () => {
        setIsModalDiagramOpen(false);
        setBsiFileDiagram(null)
        setBsiDiagramFileName('')
        setIsDiagramFileReading(false)
    };


    return (
        <div className="bsi-page">
            <div className="bsi-page__header">
                <div>
                    <h1>БСИ</h1>
                    <p>Загрузка, проверка и просмотр данных по проходкам экипажей</p>
                </div>
                <div className="bsi-page__summary">
                    <span>TXT-файлы</span>
                    <strong>БСИ экипажей</strong>
                </div>
            </div>

            {tabsValue?.name === "Загрузка" &&
                (<Grid className="bsi-actions" cols="4" gap="m">
                    <GridItem col={2}>
                        <div className="bsi-upload-card">
                            <DragNDropField multiple={true}
                                            onDropFiles={(files) => handleDropFiles(files)}
                                            accept={['.txt']}>
                                {({openFileDialog}) => (
                                    <div className="bsi-drop-content">
                                        <div className="bsi-drop-icon">БСИ</div>
                                        <Text weight="black" size="l">
                                            Загрузить БСИ в систему
                                        </Text>
                                        <Text size="s" view="secondary">
                                            Перетащите один или несколько TXT-файлов экипажей. После проверки откроется окно подтверждения.
                                        </Text>
                                        <Button size='s' view="primary" onClick={openFileDialog} label="Выбрать файлы"/>
                                    </div>
                                )}
                            </DragNDropField>
                        </div>
                    </GridItem>
                    <GridItem col={2}>
                        <div className="bsi-upload-card bsi-upload-card--diagram">
                            <DragNDropField multiple={false}
                                            onDropFiles={(files) => handleDropFilesDiagram(files)}
                                            accept={['.txt']}>
                                {({openFileDialog}) => (
                                    <div className="bsi-drop-content">
                                        <div className="bsi-drop-icon bsi-drop-icon--diagram">График</div>
                                        <Text weight="black" size="l">
                                            Быстро открыть диаграмму
                                        </Text>
                                        <Text size="s" view="secondary">
                                            Для просмотра без загрузки в график выберите один TXT-файл БСИ.
                                        </Text>
                                        <Button size='s' view="secondary" onClick={openFileDialog} label="Открыть файл"/>
                                    </div>
                                )}
                            </DragNDropField>
                        </div>
                    </GridItem>
                </Grid>)}

            <div className="bsi-table-card">
                <div className="bsi-table-card__head">
                    <div>
                        <h2>{tabsValue?.name === "Загрузка"
                            ? 'Загруженные БСИ'
                            : tabsValue?.name === "Сервер"
                                ? 'БСИ с сервера'
                                : 'Автозагрузка БСИ'}</h2>
                        <p>{tabsValue?.name === "Загрузка"
                            ? 'История файлов, которые уже обработаны и доступны в системе'
                            : tabsValue?.name === "Сервер"
                                ? 'Данные, полученные напрямую с серверных устройств экипажей'
                                : 'Очередь сопоставления серверных БСИ со скважинами и графиком'}</p>
                    </div>
                    <Tabs
                        value={tabsValue}
                        size="s"
                        view="bordered"
                        linePosition="bottom"
                        fitMode="scroll"
                        onChange={({value}) => setTabsValue(value)}
                        items={items}
                        getItemLabel={(item) => item.name}
                    />
                </div>
                {tabsValue?.name === "Загрузка" &&
                    <GridBsiBsiList key="uploaded" newRowData={newRowData} fromUploaded={false}/>
                }
                {tabsValue?.name === "Сервер" &&
                    <>
                        <TehsmartServerPanel/>
                        <GridBsiBsiList key="server" newRowData={newRowData} fromUploaded={true}/>
                    </>
                }
                {tabsValue?.name === "Автозагрузка" &&
                    <AutoLoadPanel/>
                }
            </div>

            <ModalBsiPayload isOpen={isModalOpen}
                             onClose={handleModalClose}
                             files={files}
                             nodeData={null}/>
            {isModalDiagramOpen && (
                <ModalBsiDiagram isOpen={isModalDiagramOpen}
                                 onClose={handleModalDiagramClose}
                                 bsiFileDiagram={bsiFileDiagram}
                                 localFileName={bsiDiagramFileName}
                                 localFileReading={isDiagramFileReading}
                />
            )}

            {showSnackbar && processingData.length > 0 && (
                <SnackCmp
                    key={JSON.stringify(processingData)}
                    alertText={''}
                    processingData={processingData}
                    alertType={'normal'}
                />
            )}
        </div>
    )
}

function AutoLoadPanel() {
    const [rows, setRows] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [activeStatus, setActiveStatus] = useState('')
    const [dateFrom, setDateFrom] = useState(() => {
        const value = new Date()
        value.setDate(value.getDate() - 7)
        return value.toISOString().slice(0, 10)
    })
    const [dateTo, setDateTo] = useState(() => new Date().toISOString().slice(0, 10))
    const [search, setSearch] = useState('')
    const [autoDiagramFileName, setAutoDiagramFileName] = useState<string>('')
    const [autoDiagramInfo, setAutoDiagramInfo] = useState<string>('')
    const [isAutoDiagramOpen, setIsAutoDiagramOpen] = useState(false)

    const fetchMatches = async () => {
        setLoading(true)
        setError('')
        try {
            const response = await http.get(API_BSI_AUTO_MATCHES, {
                params: {
                    date_from: dateFrom || undefined,
                    date_to: dateTo || undefined,
                    q: search || undefined,
                },
            })
            setRows(response.data || [])
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось получить очередь автозагрузки')
        } finally {
            setLoading(false)
        }
    }

    const refreshMatches = async () => {
        setLoading(true)
        setError('')
        try {
            await http.post(API_BSI_AUTO_MATCHES_REFRESH, {
                limit: 500,
                date_from: dateFrom || undefined,
                date_to: dateTo || undefined,
            })
            await fetchMatches()
        } catch (err: any) {
            setError(err.response?.data?.detail || 'Не удалось обновить автосопоставление')
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchMatches()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const counts = rows.reduce((acc: any, item: any) => {
        acc[item.status] = (acc[item.status] || 0) + 1
        return acc
    }, {})

    const filteredRows = activeStatus ? rows.filter((item: any) => item.status === activeStatus) : rows
    const wellGroups = Object.values(rows.reduce((acc: any, item: any) => {
        const wellKey = item.matched_well || item.source_well || item.id
        if (!acc[wellKey]) {
            acc[wellKey] = {
                key: wellKey,
                well: item.matched_well_name || item.source_well || 'Не указана',
                sourceWell: item.source_well,
                bush: item.matched_bush_name || item.source_bush || '—',
                deposit: item.matched_deposit_name || item.source_deposit || '—',
                org: item.org_name || '—',
                equipages: new Set(),
                count: 0,
                maxDepth: null,
                statuses: {},
                first: item,
            }
        }
        acc[wellKey].count += 1
        acc[wellKey].equipages.add(item.equipage_name || '—')
        const depth = normalizeDepth(item.depth)
        if (typeof depth === 'number') {
            acc[wellKey].maxDepth = acc[wellKey].maxDepth === null ? depth : Math.max(acc[wellKey].maxDepth, depth)
        }
        acc[wellKey].statuses[item.status_display || item.status || '—'] = (acc[wellKey].statuses[item.status_display || item.status || '—'] || 0) + 1
        return acc
    }, {})).sort((left: any, right: any) => right.count - left.count)

    const setStatusFilter = (status: string) => {
        const next = activeStatus === status ? '' : status
        setActiveStatus(next)
    }

    const openAutoDiagram = (item: any) => {
        setAutoDiagramFileName(item.uploaded_bsi)
        setAutoDiagramInfo(`${item.equipage_name || 'Экипаж'} · ${formatDate(item.work_date)} · ${item.source_well || item.matched_well_name || 'скважина не указана'}`)
        setIsAutoDiagramOpen(true)
    }

    const selectWellGroup = (group: any) => {
        setSearch(group.sourceWell || group.well)
        setActiveStatus('')
    }

    return (
        <div className="bsi-auto">
            <div className="bsi-auto__toolbar">
                <div>
                    <h3>Очередь автозагрузки</h3>
                    <p>Показывает, какие серверные БСИ можно уверенно сопоставить с графиком, а какие требуют ручной проверки.</p>
                </div>
                <button type="button" onClick={refreshMatches} disabled={loading}>
                    {loading ? 'Обновляем...' : 'Обновить очередь'}
                </button>
            </div>

            <div className="bsi-auto__filters">
                <label>
                    С
                    <input type="date" value={dateFrom} onChange={(event) => setDateFrom(event.target.value)}/>
                </label>
                <label>
                    По
                    <input type="date" value={dateTo} onChange={(event) => setDateTo(event.target.value)}/>
                </label>
                <label>
                    Скважина / куст
                    <input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Например 43764"/>
                </label>
                <button type="button" onClick={fetchMatches} disabled={loading}>Показать</button>
            </div>

            <div className="bsi-auto__counters">
                <AutoCounter label="Всего" value={rows.length} active={!activeStatus} onClick={() => setActiveStatus('')}/>
                <AutoCounter label="Готово" value={counts.READY || 0} active={activeStatus === 'READY'} onClick={() => setStatusFilter('READY')} tone="green"/>
                <AutoCounter label="Нет графика" value={counts.GRAPH_NOT_FOUND || 0} active={activeStatus === 'GRAPH_NOT_FOUND'} onClick={() => setStatusFilter('GRAPH_NOT_FOUND')} tone="yellow"/>
                <AutoCounter label="Не найдена" value={counts.WELL_NOT_FOUND || 0} active={activeStatus === 'WELL_NOT_FOUND'} onClick={() => setStatusFilter('WELL_NOT_FOUND')} tone="red"/>
                <AutoCounter label="Конфликт" value={counts.WELL_CONFLICT || 0} active={activeStatus === 'WELL_CONFLICT'} onClick={() => setStatusFilter('WELL_CONFLICT')} tone="blue"/>
                <AutoCounter label="Подозрение" value={counts.SUSPICIOUS_WELL_NUMBER || 0} active={activeStatus === 'SUSPICIOUS_WELL_NUMBER'} onClick={() => setStatusFilter('SUSPICIOUS_WELL_NUMBER')} tone="orange"/>
                <AutoCounter label="Без номера" value={counts.NO_SOURCE_WELL || 0} active={activeStatus === 'NO_SOURCE_WELL'} onClick={() => setStatusFilter('NO_SOURCE_WELL')} tone="gray"/>
            </div>

            {error && <div className="tehsmart-error">{error}</div>}
            {loading && <div className="tehsmart-note">Обновляем очередь автозагрузки...</div>}

            <div className="bsi-auto-wells">
                <div className="bsi-auto-wells__head">
                    <div>
                        <h3>Скважины за период</h3>
                        <p>Сводка по номерам, которые пришли с Tehsmart или были найдены в базе.</p>
                    </div>
                    <span>{wellGroups.length}</span>
                </div>
                <div className="bsi-auto-wells__list">
                    {wellGroups.map((group: any) => (
                        <div key={group.key} className="bsi-auto-well">
                            <button type="button" className="bsi-auto-well__main" onClick={() => selectWellGroup(group)}>
                                <strong>{group.well}</strong>
                                <span>{group.deposit} · куст {group.bush}</span>
                            </button>
                            <span>{group.org}</span>
                            <span>{Array.from(group.equipages).join(', ')}</span>
                            <strong>{group.count}</strong>
                            <span>{formatDepth(group.maxDepth)}</span>
                            <span>{Object.entries(group.statuses).map(([name, count]) => `${name}: ${count}`).join(', ')}</span>
                            <button type="button" className="bsi-auto-table__button" onClick={() => openAutoDiagram(group.first)}>
                                БСИ
                            </button>
                        </div>
                    ))}
                    {!loading && wellGroups.length === 0 && (
                        <div className="bsi-auto-table__empty">За выбранный период скважины не найдены</div>
                    )}
                </div>
            </div>

            <div className="bsi-auto-table">
                <div className="bsi-auto-table__row bsi-auto-table__row--head">
                    <span>Статус</span>
                    <span>Дата</span>
                    <span>Подрядчик</span>
                    <span>Экипаж</span>
                    <span>Tehsmart</span>
                    <span>Найдено</span>
                    <span>Загрузок</span>
                    <span>Глубина</span>
                    <span>Причина</span>
                    <span>Действие</span>
                </div>
                {filteredRows.map((item: any) => (
                    <div key={item.id} className={`bsi-auto-table__row is-${String(item.status || '').toLowerCase()}`}>
                        <span>{item.status_display}</span>
                        <span>{formatDate(item.work_date)}</span>
                        <span>{item.org_name || '—'}</span>
                        <span>{item.equipage_name || '—'}</span>
                        <span>
                            <strong>{item.source_well || '—'}</strong>
                            <small>{item.source_deposit || '—'} · куст {item.source_bush || '—'}</small>
                        </span>
                        <span>
                            <strong>{item.matched_well_name || '—'}</strong>
                            <small>{item.matched_deposit_name || '—'} · куст {item.matched_bush_name || '—'}</small>
                        </span>
                        <span>{item.same_well_uploads || 1}</span>
                        <span>{formatDepth(item.depth)}</span>
                        <span>{item.reason || '—'}</span>
                        <span>
                            <button type="button" className="bsi-auto-table__button" onClick={() => openAutoDiagram(item)}>
                                График БСИ
                            </button>
                        </span>
                    </div>
                ))}
                {!loading && filteredRows.length === 0 && (
                    <div className="bsi-auto-table__empty">Нет записей для выбранного фильтра</div>
                )}
            </div>

            {isAutoDiagramOpen && autoDiagramFileName && (
                <ModalBsiDiagram
                    isOpen={isAutoDiagramOpen}
                    onClose={() => setIsAutoDiagramOpen(false)}
                    fileName={autoDiagramFileName}
                    equipageInfo={autoDiagramInfo}
                />
            )}
        </div>
    )
}

function AutoCounter({label, value, active, onClick, tone = ''}: any) {
    return (
        <button type="button" className={`bsi-auto-counter ${tone ? `is-${tone}` : ''} ${active ? 'is-active' : ''}`} onClick={onClick}>
            <span>{label}</span>
            <strong>{value}</strong>
        </button>
    )
}

function TehsmartServerPanel() {
    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [selectedDevice, setSelectedDevice] = useState<any>(null)
    const [archiveDate, setArchiveDate] = useState(() => new Date().toISOString().slice(0, 10))
    const [archiveData, setArchiveData] = useState<any>(null)
    const [archiveLoading, setArchiveLoading] = useState(false)
    const [archiveError, setArchiveError] = useState('')

    const rows = data?.results || []
    const totals = data?.totals || {}
    const groupedRows = groupBy(rows, 'token_org_name')

    const refreshStatus = async () => {
        setLoading(true)
        setError('')
        setData(null)
        try {
            const response = await http.post(API_BSI_TEHSMART_REFRESH)
            const requestId = response.data.requestId
            pollTask(requestId)
        } catch (err: any) {
            setLoading(false)
            setError(err.response?.data?.detail || 'Не удалось запустить обновление Tehsmart')
        }
    }

    const pollTask = async (requestId: string) => {
        try {
            const response = await http.get(API_DRAMATIQ_TASK_RESULT, {
                params: {requestId},
            })
            const task = response.data
            if (!task) {
                window.setTimeout(() => pollTask(requestId), 2000)
                return
            }
            if (task.status === 'ERROR') {
                setLoading(false)
                setError(task.error || 'Ошибка фоновой задачи Tehsmart')
                return
            }
            if (task.status === 'DONE') {
                setLoading(false)
                setData(task.data)
                return
            }
            window.setTimeout(() => pollTask(requestId), 2000)
        } catch (err: any) {
            setLoading(false)
            setError(err.response?.data?.detail || 'Не удалось получить результат обновления')
        }
    }

    const openArchive = async (device: any) => {
        setSelectedDevice(device)
        setArchiveData(null)
        setArchiveError('')
        setArchiveLoading(true)
        try {
            const response = await http.get(API_BSI_TEHSMART_ARCHIVE, {
                params: {
                    serialNo: device.serial_no,
                    date: archiveDate,
                    tokenOrgId: device.token_org_id,
                },
            })
            setArchiveData(response.data)
        } catch (err: any) {
            setArchiveError(err.response?.data?.error || 'Не удалось получить архив прибора')
        } finally {
            setArchiveLoading(false)
        }
    }

    useEffect(() => {
        if (selectedDevice) {
            openArchive(selectedDevice)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [archiveDate])

    return (
        <div className="tehsmart-panel">
            <div className="tehsmart-panel__head">
                <div>
                    <h3>Tehsmart Online</h3>
                    <p>Мониторинг приборов СКК-311 по подрядчикам. Архив загружается только при открытии прибора.</p>
                </div>
                <button type="button" onClick={refreshStatus} disabled={loading}>
                    {loading ? 'Обновляем...' : 'Обновить с Tehsmart'}
                </button>
            </div>

            {(data || loading || error) && (
                <div className="tehsmart-panel__body">
                    <div className="tehsmart-counters">
                        <TehsmartCounter label="Всего" value={totals.total || 0}/>
                        <TehsmartCounter label="На связи" value={totals.online || 0} accent="green"/>
                        <TehsmartCounter label="За сутки" value={totals.stale || 0} accent="yellow"/>
                        <TehsmartCounter label="Молчат" value={totals.silent || 0} accent="red"/>
                        <TehsmartCounter label="Нет в АСПО" value={totals.unknown_devices || 0} accent="blue"/>
                        <TehsmartCounter label="Не привязаны" value={totals.not_linked || 0} accent="gray"/>
                        <TehsmartCounter label="Server mode выкл." value={totals.server_mode_off || 0} accent="orange"/>
                    </div>

                    {loading && <div className="tehsmart-note">Обновляем данные Tehsmart...</div>}
                    {error && <div className="tehsmart-error">{error}</div>}
                    {data?.errors?.length > 0 && (
                        <div className="tehsmart-error">
                            {data.errors.map((item: any) => (
                                <span key={item.org_id}>{item.org_name}: {item.message}</span>
                            ))}
                        </div>
                    )}

                    {rows.length > 0 && (
                        <div className="tehsmart-groups">
                            {Object.entries(groupedRows).map(([orgName, items]: any) => (
                                <div key={orgName} className="tehsmart-group">
                                    <div className="tehsmart-group__head">
                                        <strong>{orgName}</strong>
                                        <span>{items.length}</span>
                                    </div>
                                    <div className="tehsmart-table">
                                        <div className="tehsmart-table__row tehsmart-table__row--head">
                                            <span>Прибор</span>
                                            <span>Экипаж</span>
                                            <span>Последний сигнал</span>
                                            <span>Глубина</span>
                                            <span>Статус</span>
                                            <span>АСПО</span>
                                        </div>
                                        {items.map((item: any) => (
                                            <button
                                                key={item.id}
                                                type="button"
                                                className={`tehsmart-table__row is-${String(item.status || '').toLowerCase()}`}
                                                onClick={() => openArchive(item)}
                                            >
                                                <span>{item.serial_no}</span>
                                                <span>{item.equipage_name || 'Не привязан'}</span>
                                                <span>{formatDateTime(item.last_on_time)}</span>
                                                <span>{formatDepth(item.depth)}</span>
                                                <span>{item.status_display}</span>
                                                <span>{item.is_known_device ? (item.equipage_server_mode ? 'server mode' : 'есть') : 'нет'}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {selectedDevice && (
                <div className="tehsmart-modal-overlay" onClick={() => setSelectedDevice(null)}>
                    <div className="tehsmart-modal" onClick={(event) => event.stopPropagation()}>
                        <div className="tehsmart-modal__head">
                            <div>
                                <h3>Прибор {selectedDevice.serial_no}</h3>
                                <p>{selectedDevice.token_org_name} · {selectedDevice.equipage_name || 'экипаж не привязан'}</p>
                            </div>
                            <button type="button" onClick={() => setSelectedDevice(null)}>Закрыть</button>
                        </div>
                        <div className="tehsmart-modal__toolbar">
                            <label>
                                Дата архива
                                <input
                                    type="date"
                                    value={archiveDate}
                                    onChange={(event) => setArchiveDate(event.target.value)}
                                />
                            </label>
                            <button type="button" onClick={() => openArchive(selectedDevice)} disabled={archiveLoading}>
                                {archiveLoading ? 'Загружаем...' : 'Обновить день'}
                            </button>
                        </div>
                        {archiveError && <div className="tehsmart-error">{archiveError}</div>}
                        {archiveLoading && <div className="tehsmart-note">Загружаем архив прибора...</div>}
                        {archiveData && (
                            <div className="tehsmart-archive">
                                <div className="tehsmart-archive__summary">
                                    <TehsmartInfo label="Строк" value={archiveData.summary?.rows_total}/>
                                    <TehsmartInfo label="Макс. глубина" value={formatDepth(archiveData.summary?.max_depth)}/>
                                    <TehsmartInfo label="Месторождение" value={archiveData.summary?.area || '—'}/>
                                    <TehsmartInfo label="Куст" value={archiveData.summary?.bush || '—'}/>
                                    <TehsmartInfo label="Скважина" value={archiveData.summary?.well || '—'}/>
                                    <TehsmartInfo label="Ответственный" value={archiveData.summary?.people || '—'}/>
                                </div>
                                <DepthChart points={archiveData.points || []}/>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

function TehsmartCounter({label, value, accent = ''}: any) {
    return (
        <div className={`tehsmart-counter ${accent ? `is-${accent}` : ''}`}>
            <span>{label}</span>
            <strong>{value}</strong>
        </div>
    )
}

function TehsmartInfo({label, value}: any) {
    return (
        <div className="tehsmart-info">
            <span>{label}</span>
            <strong>{value ?? '—'}</strong>
        </div>
    )
}

function DepthChart({points}: any) {
    const cleanPoints = (points || [])
        .map((item: any) => ({...item, depth: normalizeDepth(item.depth)}))
        .filter((item: any) => typeof item.depth === 'number')
    if (cleanPoints.length < 2) {
        return <div className="tehsmart-chart tehsmart-chart--empty">Недостаточно точек для графика</div>
    }
    const width = 900
    const height = 220
    const maxDepth = Math.max(...cleanPoints.map((item: any) => item.depth || 0), 1)
    const linePoints = cleanPoints.map((item: any, index: number) => {
        const x = (index / (cleanPoints.length - 1)) * width
        const y = height - ((item.depth || 0) / maxDepth) * (height - 20) - 10
        return `${x.toFixed(1)},${y.toFixed(1)}`
    }).join(' ')

    return (
        <div className="tehsmart-chart">
            <div className="tehsmart-chart__head">
                <strong>Глубина</strong>
                <span>макс. {formatDepth(maxDepth)} м · точек {cleanPoints.length}</span>
            </div>
            <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
                <polyline points={linePoints} fill="none" stroke="#175cd3" strokeWidth="3"/>
            </svg>
        </div>
    )
}

function groupBy(rows: any[], key: string) {
    return rows.reduce((acc: any, item: any) => {
        const groupKey = item[key] || 'Без группы'
        if (!acc[groupKey]) acc[groupKey] = []
        acc[groupKey].push(item)
        return acc
    }, {})
}

function formatDateTime(value: string | null) {
    if (!value) return '—'
    return new Date(value).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })
}

function formatDate(value: string | null) {
    if (!value) return '—'
    return new Date(value).toLocaleDateString('ru-RU')
}

function normalizeDepth(value: any) {
    if (value === null || value === undefined || value === '') return null
    const numberValue = Number(value)
    if (Number.isNaN(numberValue)) return null
    return Math.abs(numberValue) >= 10000 ? numberValue / 100 : numberValue
}

function formatDepth(value: any) {
    const depth = normalizeDepth(value)
    if (depth === null) return '—'
    return depth.toFixed(depth % 1 === 0 ? 0 : 2)
}

export default PageBsi;
